module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/screen.0b65200e.jpg";